// Contract addresses on BSC/opBNB
export const CONTRACT_ADDRESSES = {
  // Replace these with your actual deployed contract addresses
  DIVIDEND_CONTRACT: '0x7418ed04e33F4Ce31B6d889c2A9E051C01fa6178', // Your dividend contract address
  CRYPTOFLIP_CONTRACT: '0x4c1a98DC42faAF61F287Cb639e37f3a15BA69189', // Your CryptoFlip contract address
  BLB_TOKEN: '0x9015e335f28cbad84EB255d5205CDb51B08A1B70', // Your BLB token contract address
};

// Network configuration
export const NETWORK_CONFIG = {
  chainId: 56, // BNB Smart Chain mainnet
  chainName: 'BNB Smart Chain',
  rpcUrls: [
    'https://bsc-dataseed1.binance.org/',
    'https://bsc-dataseed2.binance.org/',
    'https://bsc-dataseed3.binance.org/'
  ],
  blockExplorerUrls: ['https://bscscan.com'],
  nativeCurrency: {
    name: 'BNB',
    symbol: 'BNB',
    decimals: 18
  }
};

// Game configuration
export const GAME_CONFIG = {
  CRYPTOFLIP: {
    minBet: '1', // 1 BLB
    maxBet: '1000000', // 1M BLB
    houseEdge: 5, // 5%
    winMultiplier: 1.95 // 1.95x after deductions
  }
};